// src/contexts/NotificationContext.js
import React, { createContext, useState, useContext, useCallback } from 'react';

const NotificationContext = createContext();

export const useNotification = () => useContext(NotificationContext);

export const NotificationProvider = ({ children }) => {
  const [notifications, setNotifications] = useState([]);

  // Remove a notification by id
  const removeNotification = useCallback(id => {
    setNotifications(prev => prev.filter(notification => notification.id !== id));
  }, []);

  // Show a notification
  const showNotification = useCallback(
    (message, type = 'info', duration = 5000) => {
      const id = Date.now();

      setNotifications(prev => [...prev, { id, message, type, duration }]);

      // Auto-remove notification after duration
      setTimeout(() => {
        removeNotification(id);
      }, duration);

      return id;
    },
    [removeNotification]
  );

  const value = {
    notifications,
    showNotification,
    removeNotification,
  };

  return <NotificationContext.Provider value={value}>{children}</NotificationContext.Provider>;
};

export default NotificationContext;
